import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * Species
 */
export class Species {
    /**
     * getList
     */
    static async getList() {
        const result = await NetFetch.getData('/json/species/list');
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return result.list;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return null;
    }
    /**
     * save
     * @param specie
     */
    static async save(specie) {
        const result = await NetFetch.postData('/json/species/save', specie);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return true;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return false;
    }
    /**
     * merge
     * @param merge
     */
    static async merge(merge) {
        const result = await NetFetch.postData('/json/species/merge', merge);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return true;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return false;
    }
    /**
     * Fetch the per-species profile (counts, group-size histogram, env
     * distributions). Period bounds are optional — omit for the full
     * data range.
     */
    static async getProfile(speciesId, periodFrom, periodTo) {
        const body = { species_id: speciesId };
        if (periodFrom) {
            body.period_from = periodFrom;
        }
        if (periodTo) {
            body.period_to = periodTo;
        }
        const result = await NetFetch.postData('/json/species/profile', body);
        if (result && result.statusCode === StatusCodes.UNAUTHORIZED) {
            throw new UnauthorizedError();
        }
        if (result && result.statusCode === StatusCodes.OK && result.profile) {
            return result.profile;
        }
        return null;
    }
    /**
     * Cross-species regression matrix (4 scatter charts + pooled fits)
     * for Simpson-paradox visibility. Period bounds optional.
     */
    static async getRegressionMatrix(periodFrom, periodTo) {
        var _a;
        const body = {};
        if (periodFrom) {
            body.period_from = periodFrom;
        }
        if (periodTo) {
            body.period_to = periodTo;
        }
        const result = await NetFetch.postData('/json/species/regression-matrix', body);
        if (result && result.statusCode === StatusCodes.UNAUTHORIZED) {
            throw new UnauthorizedError();
        }
        if (result && result.statusCode === StatusCodes.OK) {
            return (_a = result.charts) !== null && _a !== void 0 ? _a : [];
        }
        return null;
    }
    /**
     * delete
     * @param sdelete
     */
    static async delete(sdelete) {
        const result = await NetFetch.postData('/json/species/delete', sdelete);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return true;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
                default:
                    if (result.msg) {
                        throw Error(result.msg);
                    }
            }
        }
        return false;
    }
}
